<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" ref="wrapper" @click="cancelWrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              default header
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="modal-button default" @click="ok">
                OK
              </button>
              <button class="modal-button" @click="cancel">
                Cancel
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  // source: https://vuejs.org/v2/examples/modal.html
  import './Modal.scss'

  export default {
    name: 'modal',

    methods: {
      ok: function () {
        this.$emit('ok')
      },

      cancel: function () {
        this.$emit('cancel')
      },

      cancelWrapper: function (event) {
        if (event.target === this.$refs.wrapper) {
          this.$emit('cancel')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Modal.vue?f5711256